/**
 * Theme-aware recharts styling.
 *
 * Recharts takes plain inline style objects, so it never picks up the Tailwind
 * palette remap in tailwind.config.js and cannot flip with the theme on its
 * own. Every chart therefore used to pin its tooltip to a single theme — the
 * dashboard to dark (unreadable panel on a light page), payroll and the
 * financial stats to light (white popover on a dark page) — while the charts
 * that passed no background at all fell back to recharts' hard-coded white.
 *
 * Referencing the same CSS custom properties as index.css (`:root` = light,
 * `.dark` = dark) makes the tooltip follow the active theme.
 */
export const CHART_TOOLTIP_STYLE = {
  backgroundColor: 'var(--popover)',
  border: '1px solid var(--border)',
  borderRadius: 8,
  color: 'var(--popover-foreground)',
  fontSize: 12,
} as const;

/** Header line of a tooltip (the category/date above the values). */
export const CHART_TOOLTIP_LABEL_STYLE = { color: 'var(--popover-foreground)' } as const;

/**
 * Value lines of a tooltip. Recharts colours each line with the series colour
 * and falls back to black when a series has none — a pie slice carries its
 * colour on the Cell, not the series, so its tooltip line came out black on
 * the dark popover. Pass this on tooltips whose lines have no series colour.
 */
export const CHART_TOOLTIP_ITEM_STYLE = { color: 'var(--popover-foreground)' } as const;
